import { createStore } from 'vuex'
import auth from '@/modules/auth/store/index'

export default createStore({
  state: {

  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth
  }
})
